import React, { useContext, useState, useRef, useEffect } from 'react';
import { Row, Col, Form, Label, Input } from 'reactstrap';
import styles from './ReviewPlanDetails.module.css';
import classNames from 'classnames';
import SaveModal from '../modals/SaveModal';
import { useHistory, useLocation } from 'react-router';
import { phoneFormat } from '../shared/util';
import OrderSummary from './OrderSummary';
import { BrandingContext } from '../contexts/ContractContext';
import { SalesContext } from '../contexts/SalesContext';
import SimpleReactValidator from 'simple-react-validator';
import useLoadAtTop from '../_ReactHooks/useLoadAtTop';
import StandardInput from '../shared/StandardInput/StandardInput';
import CallBanner from '../shared/CallBanner/CallBanner';
import { usePageTitle } from '../_ReactHooks';
import { dataLayerPush } from '../../helpers';
import getClientContent from '../_BrandingProvider/brandContent';
import SpinnerButton from '../shared/SpinnerButton/SpinnerButton';
import { useCookies } from 'react-cookie';

let btnPrimary = 'btn-primary';
let btn = 'btn';
let btnLink = 'btnLink';
let btnsecondary = 'btn-secondary';
let orderLast = 'order-last';
let orderMDFirst = 'order-md-first';
let overviewBody = styles.overviewBody;
let mrAuto = 'mr-auto';

const ReviewPlanDetails = (props) => {
    /**
     *  ================================
     *  =========== HOOKS ==============
     *  ================================
     */
    useLoadAtTop();
    usePageTitle('Review Plan');
    const history = useHistory();

    const branding = useContext(BrandingContext);
    const clientId = branding.clientId || 'AIG';

    let context = useContext(SalesContext);
    const { planData, formData, termsAndCondition, promocodeObj, isPromoApplied, isAgent, taxRate } = context.data;

    let { serviceAddress, mailingAddress, firstName, lastName, email, phone, serviceAsMailingAddress, planDocuments } =
        formData;
    //formData.mailingAddress = history.location.state.data?.mailingAddress;
    formData.mailingAddress = formData.serviceAsMailingAddress ? formData.serviceAddress : formData.mailingAddress;
    /**
     *  ================================
     *  =========== STATE ==============
     *  ================================
     */
    const [cookies] = useCookies();
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [, forceUpdate] = useState();
    // const taxRate = 6.625 / 100;
    const [addonsPrice, setAddonsPrice] = useState(0);
    const [totalTaxPrice, setTotalTaxPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [termConditions, setTermConditions] = useState(false);
    const [emailCheckBox, setEmailCheckBox] = useState(
        typeof planDocuments !== 'undefined' && planDocuments != ''
            ? planDocuments.includes('Email')
                ? true
                : false
            : true
    );
    const [emailInAMonth, setEmailInAMonth] = useState(
        typeof planDocuments !== 'undefined' && planDocuments != ''
            ? planDocuments.includes('Mail')
                ? true
                : false
            : false
    );
    //const [emailCheckBox, setEmailCheckBox] = useState(true);
    //const [emailInAMonth, setEmailInAMonth] = useState(false);
    const [planDocumentsEmail, setPlanDocumentsEmail] = useState(email);
    const [planDocumentsAddress, setPlanDocumentsAddress] = useState({});
    const [selectedAddress, setSelectedAddress] = useState('mailingaddress');
    const [isSameAddress, setIsSameAddress] = useState(false);
    const [validationFired, setValidationFired] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const isPayAnnual = planData && planData.plan != 'monthly';

    /**
     *  ================================
     *  =========== EFFECT =============
     *  ================================
     */
    useEffect(() => {
        calculateTotals();
        dataLayerPush('Pageview', {
            pagePath: '/review',
            pageTitle: 'NJR Retail Service Plans - Review Plan'
        });

        console.log('reviewplan details info --->', planData);
        const { selectedAddPlans, activeAddPlans, activePlan, plan, planTotal, additionalTotal, selectedPlan } =
            planData;

        const additionalPlansForGtm = [];
        selectedAddPlans.map((aP, i) =>
            additionalPlansForGtm.push({
                item_id: activeAddPlans[i],
                item_name: aP.title,
                item_category: 'add_on_plan',
                price: plan === 'monthly' ? aP.monthly : aP.yearly,
                paymentPlan: plan
            })
        );
        if (totalTaxPrice) {
            dataLayerPush('view_cart', {
                ecommerce: {
                    currency: 'USD',
                    value: planTotal + additionalTotal + totalTaxPrice,
                    tax: totalTaxPrice,
                    coupon: promocodeObj?.name,
                    items: [
                        {
                            item_name: selectedPlan.title,
                            item_id: activePlan,
                            item_category: 'primary_plan',
                            price: plan === 'monthly' ? selectedPlan.monthly : selectedPlan.yearly,
                            includes: selectedPlan.includes,
                            paymentPlan: plan
                        },
                        ...additionalPlansForGtm
                    ]
                }
            });
        }
    });

    /**
     *  ================================
     *  === CONTINUE COMPONENT LOGIC ===
     *  ================================
     */
    const simpleValidator = useRef(
        new SimpleReactValidator({
            validators: {
                terms: {
                    message: 'Please accept the terms and conditions to proceed.',
                    rule: (val, params, validator) => {
                        return val;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),
                    required: true
                }
            },
            messages: {
                terms: 'Please accept the terms and conditions to proceed.',
                email: 'Please enter a valid email.',
                required: ':attribute is required.'
            },
            element: (message) => (
                <div
                    className='errorMsg'
                    aria-live='polite'
                >
                    {message.charAt(0).toUpperCase() + message.slice(1)}
                </div>
            )
        })
    );

    const calculateTotals = () => {
        let addonsPriceLocal = 0;
        if (planData.selectedAddPlans.length) {
            if (planData.tsf.name == 'higher') {
                addonsPriceLocal = planData.selectedAddPlans.reduce((accu, cur) => accu + cur.higherTsfPrice, 0);
            } else if (planData.tsf.name == 'lower') {
                addonsPriceLocal = planData.selectedAddPlans.reduce((accu, cur) => accu + cur.lowerTsfPrice, 0);
            } else
                addonsPriceLocal = planData.selectedAddPlans.reduce(
                    (accu, cur) => accu + cur.riskProfile.totalBundlePrice,
                    0
                );
        }
        addonsPriceLocal = addonsPriceLocal.toFixed(2);
        const planPrice =
            planData?.tsf?.price == null
                ? isPayAnnual == true
                    ? parseFloat(planData.selectedPlan.yearly || 0).toFixed(2)
                    : parseFloat(planData.planTotal).toFixed(2)
                : planData?.tsf?.price;

        let promoPrice = 0;
        let totalPrice = 0;
        if (promocodeObj) {
            promoPrice = promocodeObj.value;

            if (promocodeObj.type == 'percent') {
                promoPrice = planPrice * (promocodeObj.value / 100);
            }
            promocodeObj.promoPrice = promoPrice.toFixed(2);
        }

        const basePlan = parseFloat((planPrice - parseFloat(promoPrice)).toFixed(2));

        const totalTax = parseFloat(((basePlan + parseFloat(addonsPriceLocal)) * parseFloat(taxRate)).toFixed(2));
        totalPrice = parseFloat(basePlan + parseFloat(addonsPriceLocal) + totalTax).toFixed(2);
        setAddonsPrice(addonsPriceLocal);
        setTotalTaxPrice(totalTax);
        setTotalPrice(totalPrice);
    };
    const checkObjectsEqual = (obj1, obj2) => {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };

    useEffect(() => {
        let isSame = checkObjectsEqual(serviceAddress, mailingAddress);
        calculateTotals();
        setIsSameAddress(isSame);
    });

    const handleEdit = () => {
        history.push({
            pathname: '/customerinfo'
        });
    };

    const handleContinue = (e) => {
        e.preventDefault();

        if (!emailCheckBox && !emailInAMonth) {
            setErrorMessage('Please select an option to continue.');
            return;
        }
        setValidationFired(true);

        if (simpleValidator.current.allValid()) {
            setIsLoading(true);
            var selectedAddPlans = [];
            var addOns = planData.selectedAddPlans.map((i) => i.riskProfile);
            for (var i = 0; i < addOns.length; i++) {
                selectedAddPlans.push({ riskProfile: addOns[i] });
            }
            let planDocumentData = '';
            if (emailCheckBox && emailInAMonth) planDocumentData = 'Email_Mail';
            else if (emailInAMonth) planDocumentData = 'Mail';
            else planDocumentData = 'Email';

            planDocuments = planDocumentData;
            formData.planDocuments = planDocumentData;

            let planDetails = {
                invitationNumber: formData.invitationNumber ?? '0',
                amount: totalPrice,
                clientId: clientId,
                firstName: formData.firstName,
                lastName: formData.lastName,
                phone: formData.phone,
                email: formData.email,
                doNotSolicit: formData.doNotSolicit ? formData.doNotSolicit : new Date('01/01/01'),
                riskProfileModel: planData.selectedPlan?.riskProfile,
                yearlyRiskProfileModel: planData.selectedPlan?.yearlyRiskProfile,
                activeAddPlans: planData.selectedAddPlans.map((i) => i.riskProfile),
                activeAddPlansYearly: planData.activeAddPlansYearly.map((i) => i.riskProfile),
                planData: {
                    selectedPlan: {
                        riskProfile: planData.selectedPlan?.riskProfile
                    },
                    selectedAddPlans: selectedAddPlans,
                    activePlan: planData?.activePlan,
                    activeAddPlans: planData?.activeAddPlans,
                    activeAddPlansYearly: planData?.activeAddPlansYearly,
                    plan: planData?.plan,
                    annualPlanTotal: planData?.tsf == null ? planData?.selectedPlan?.yearly : planData?.tsf.yearlyPrice,
                    tsf: planData?.tsf
                },
                termsAndCondition: termsAndCondition,
                verifiedAddress: {
                    address1: formData.mailingAddress.address1,
                    address2: formData.mailingAddress.address2,
                    city: formData.mailingAddress.city,
                    state: formData.mailingAddress.state,
                    stateId: formData.mailingAddress.stateId,
                    zip: formData.mailingAddress.zip
                },
                billingAddress: {
                    address1: formData.billingAddress.address1,
                    address2: formData.billingAddress.address2,
                    city: formData.billingAddress.city,
                    state: formData.billingAddress.state,
                    stateId: formData.billingAddress.stateId,
                    zip: formData.billingAddress.zip
                },
                serviceAddress: {
                    address1: formData.serviceAddress.address1,
                    address2: formData.serviceAddress.address2,
                    city: formData.serviceAddress.city,
                    state: formData.serviceAddress.state,
                    stateId: formData.serviceAddress.stateId,
                    zip: formData.serviceAddress.zip
                },
                mailingAddress: {
                    address1: serviceAsMailingAddress
                        ? formData.serviceAddress.address1
                        : formData.mailingAddress.address1,
                    address2: serviceAsMailingAddress
                        ? formData.serviceAddress.address2
                        : formData.mailingAddress.address2,
                    city: serviceAsMailingAddress ? formData.serviceAddress.city : formData.mailingAddress.city,
                    state: serviceAsMailingAddress ? formData.serviceAddress.state : formData.mailingAddress.state,
                    stateId: serviceAsMailingAddress
                        ? formData.serviceAddress.stateId
                        : formData.mailingAddress.stateId,
                    zip: serviceAsMailingAddress ? formData.serviceAddress.zip : formData.mailingAddress.zip
                },
                promoCode: promocodeObj?.name,
                taxAmount: totalTaxPrice,
                planDocumentsEmail: emailCheckBox ? planDocumentsEmail : '',
                planDocumentsAddress: emailInAMonth ? selectedAddress : '',
                planDocumentsType: formData.planDocuments,
                isAgent: isAgent,
                taxRate: taxRate,
                tsf: parseFloat(planData?.tsf?.term)?.toFixed(2)
            };

            // console.log(planDetails, context.data)

            let statusCode = 0;
            fetch(`api/Contract/CreatePlanContract/${clientId}/${isAgent}`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    XSRFTOKEN: cookies.XSRFTOKEN
                },
                body: JSON.stringify({
                    invitationNumber: formData.invitationNumber ?? '0',
                    amount: totalPrice,
                    clientId: clientId,
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    phone: formData.phone,
                    email: formData.email,
                    doNotSolicit: formData.doNotSolicit ? formData.doNotSolicit : new Date('01/01/01'),
                    riskProfileModel: planData.selectedPlan?.riskProfile,
                    activeAddPlans: planData.selectedAddPlans.map((i) => i.riskProfile),
                    planData: {
                        selectedPlan: {
                            riskProfile: planData.selectedPlan?.riskProfile
                        },
                        selectedAddPlans: selectedAddPlans,
                        activePlan: planData?.activePlan,
                        activeAddPlans: planData?.activeAddPlans,
                        plan: planData?.plan
                    },
                    termsAndCondition: termsAndCondition,
                    verifiedAddress: {
                        address1: formData.mailingAddress.address1,
                        address2: formData.mailingAddress.address2,
                        city: formData.mailingAddress.city,
                        state: formData.mailingAddress.state,
                        stateId: formData.mailingAddress.stateId,
                        zip: formData.mailingAddress.zip
                    },
                    billingAddress: {
                        address1: formData.serviceAddress.address1,
                        address2: formData.serviceAddress.address2,
                        city: formData.serviceAddress.city,
                        state: formData.serviceAddress.state,
                        stateId: formData.serviceAddress.stateId,
                        zip: formData.serviceAddress.zip
                    },
                    serviceAddress: {
                        address1: formData.serviceAddress.address1,
                        address2: formData.serviceAddress.address2,
                        city: formData.serviceAddress.city,
                        state: formData.serviceAddress.state,
                        stateId: formData.serviceAddress.stateId,
                        zip: formData.serviceAddress.zip
                    },
                    mailingAddress: {
                        address1: serviceAsMailingAddress
                            ? formData.serviceAddress.address1
                            : formData.mailingAddress.address1,
                        address2: serviceAsMailingAddress
                            ? formData.serviceAddress.address2
                            : formData.mailingAddress.address2,
                        city: serviceAsMailingAddress ? formData.serviceAddress.city : formData.mailingAddress.city,
                        state: serviceAsMailingAddress ? formData.serviceAddress.state : formData.mailingAddress.state,
                        stateId: serviceAsMailingAddress
                            ? formData.serviceAddress.stateId
                            : formData.mailingAddress.stateId,
                        zip: serviceAsMailingAddress ? formData.serviceAddress.zip : formData.mailingAddress.zip
                    },
                    promoCode: promocodeObj?.name,
                    taxAmount: totalTaxPrice,
                    planDocumentsEmail: emailCheckBox ? planDocumentsEmail : '',
                    planDocumentsAddress: emailInAMonth ? selectedAddress : '',
                    planDocumentsType: formData.planDocuments,
                    isAgent: isAgent,
                    tsfAmount: parseFloat(planData?.tsf?.term)?.toFixed(2),
                    savedStep: ''
                })
            })
                .then(function (res) {
                    statusCode = res.status;
                    return res.json();
                })
                .then((contractData) => {
                    if (statusCode === 200) {
                        formData.invitationNumber = contractData.clientContractNumber;
                        history.push({
                            pathname: '/sales/payment',
                            state: {
                                planDetails: planDetails,
                                cookies: cookies
                            }
                        });
                    } else {
                        setIsLoading(false);
                    }
                });
            /* todo service call for getting recommended address*/
        } else {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        }
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setPlanDocumentsEmail(value);
    };

    const handleRadioChange = (e) => {
        const { id } = e.target;
        if (id === 'serviceaddress') {
            setSelectedAddress('serviceaddress');
        } else {
            setSelectedAddress('mailingaddress');
        }
    };

    const handleCheckboxChange = (e) => {
        if (e.target.id == 'emailcheckbox') {
            setEmailCheckBox(!emailCheckBox);
        } else {
            setEmailInAMonth(!emailInAMonth);
        }
        if (emailCheckBox || emailInAMonth) {
            setErrorMessage('');
        }
        simpleValidator.current.purgeFields();
    };

    const handleShowActionModal = () => {
        let planDocumentData = '';
        if (emailCheckBox && emailInAMonth) {
            planDocumentData = 'Email_Mail';
        } else if (emailInAMonth) {
            planDocumentData = 'Mail';
        } else {
            planDocumentData = 'Email';
        }

        planDocuments = planDocumentData;
        formData.planDocuments = planDocumentData;
        setShowSaveModal(true);
    };

    // APPEARS TO NOT BE IN USE. SCHEDULED FOR DELETION AFTER NEXT SUCCESSFUL TESTING
    // NPB 08/17/21
    // const handleTermsAndCondition = () => {
    //   setTermConditions(!termConditions);
    //   //context.updateTermsAndCondition(!termsAndCondition);
    // }

    const { variableText } = getClientContent(clientId);
    const phoneNumber = variableText.customerService.phone;

    return (
        <div className='container contentWrapper'>
            <Form>
                <Row>
                    <Col
                        md='7'
                        lg='6'
                        className={classNames(overviewBody, mrAuto, orderMDFirst)}
                    >
                        <h1 className='h5'>
                            <b>Review Plan Details</b>
                        </h1>
                        <Row className={styles.reviewPlanInfo}>
                            <Col>
                                <Row>
                                    <Col
                                        md='4'
                                        xs='5'
                                    >
                                        Service Plan:
                                    </Col>
                                    <Col
                                        md='6'
                                        xs='7'
                                    >
                                        {planData.selectedPlan?.title}
                                    </Col>
                                </Row>
                                {planData.selectedAddPlans.map((addon, index) => (
                                    <Row>
                                        <Col
                                            md='4'
                                            xs='5'
                                        >
                                            Add-on:
                                        </Col>
                                        <Col
                                            md='6'
                                            xs='7'
                                        >
                                            {addon.title}
                                        </Col>
                                    </Row>
                                ))}
                                {/*<Row>*/}
                                {/*    <Col md="4" xs="5">Payment Option:</Col>*/}
                                {/*    <Col md="6" xs="7">{planData.plan == 'monthly' ? "Monthly" : "Yearly"}</Col>*/}
                                {/*</Row>*/}
                                <Row>
                                    <Col
                                        md='4'
                                        xs='5'
                                    >
                                        Total:
                                    </Col>
                                    <Col
                                        md='6'
                                        xs='7'
                                    >
                                        ${totalPrice}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col
                                        md='4'
                                        xs='5'
                                    >
                                        Service Fee:
                                    </Col>
                                    <Col
                                        md='6'
                                        xs='7'
                                    >
                                        ${planData?.tsf?.term.toFixed(2)} per claim
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <h1 className='h5'>
                            <b>Your Details</b>
                        </h1>
                        <Row className={styles.reviewPlanInfo}>
                            <Col>
                                <div>
                                    {firstName} {lastName}{' '}
                                </div>
                                <div>{phoneFormat(phone)}</div>
                                <div>{email}</div>
                            </Col>
                        </Row>
                        <h1 className='h5'>
                            <b>Service Address</b>
                        </h1>
                        <Row className={styles.reviewPlanInfo}>
                            <Col>
                                <div>{serviceAddress.address1}</div>
                                <div>{serviceAddress.address2}</div>
                                <div>
                                    {serviceAddress.city}, {serviceAddress.state} {serviceAddress.zip}
                                </div>
                            </Col>
                        </Row>
                        <h1 className='h5'>
                            <b>Mailing Address</b>
                        </h1>
                        {serviceAsMailingAddress && (
                            <Row className={styles.reviewPlanInfo}>
                                <Col>
                                    <div>{serviceAddress.address1}</div>
                                    <div>{serviceAddress.address2}</div>
                                    <div>
                                        {serviceAddress.city}, {serviceAddress.state} {serviceAddress.zip}
                                    </div>
                                </Col>
                            </Row>
                        )}
                        {!serviceAsMailingAddress && (
                            <Row className={styles.reviewPlanInfo}>
                                <Col>
                                    <div>{mailingAddress.address1}</div>
                                    <div>{mailingAddress.address2}</div>
                                    <div>
                                        {mailingAddress.city}, {mailingAddress.state} {mailingAddress.zip}
                                    </div>
                                </Col>
                            </Row>
                        )}
                        <div>
                            <h3 className='h5'>Plan Documents</h3>
                            <p> We will send your coverage documents via:</p>
                            <Col className='p-0 mb-3'>
                                <div className='checkbox mb-0'>
                                    <Input
                                        className='mr-2'
                                        type='checkbox'
                                        id='emailcheckbox'
                                        checked={emailCheckBox}
                                        onChange={handleCheckboxChange}
                                    />
                                    <Label
                                        for='emailcheckbox'
                                        className={`checkboxLabel ${clientId}`}
                                    >
                                        Email within 7-14 business days
                                    </Label>
                                </div>
                                {emailCheckBox && (
                                    <div className={`${styles.documentOptions} col-10 col-md-8 `}>
                                        <StandardInput
                                            hasError={
                                                !simpleValidator.current.check(planDocumentsEmail, 'required|email')
                                                && validationFired
                                            }
                                            required={false}
                                            type='email'
                                            ariaLabelAndFieldId='email'
                                            fieldName='planDocumentEmail'
                                            value={planDocumentsEmail}
                                            onChange={handleInputChange}
                                            customClass={styles.planDocumentEmail}
                                            validator={simpleValidator.current.message(
                                                'email',
                                                planDocumentsEmail,
                                                'required|email'
                                            )}
                                        />
                                    </div>
                                )}
                            </Col>
                            <Col className='p-0 mb-5'>
                                <div className='checkbox mb-0'>
                                    <Input
                                        className='mr-2'
                                        type='checkbox'
                                        id='emailInAMonth'
                                        checked={emailInAMonth}
                                        onChange={handleCheckboxChange}
                                    />
                                    <Label
                                        for='emailInAMonth'
                                        className={`checkboxLabel ${clientId}`}
                                    >
                                        Mail within 30 days
                                    </Label>
                                </div>
                                {emailInAMonth && (
                                    <div className={`${styles.documentOptions} col`}>
                                        <div className='radio'>
                                            <Input
                                                type='radio'
                                                name='planDocumentsAddress'
                                                id='mailingAddress'
                                                onChange={handleRadioChange}
                                                checked={selectedAddress === 'mailingaddress'}
                                            />
                                            <Label
                                                className={`${styles.radioLabel} controls-label`}
                                                for='mailingAddress'
                                            >
                                                <span>
                                                    {mailingAddress.address1}, {mailingAddress.address2}{' '}
                                                    {mailingAddress.city}, {mailingAddress.state} {mailingAddress.zip}
                                                </span>
                                            </Label>
                                        </div>
                                        {!isSameAddress && (
                                            <div className='radio'>
                                                <Input
                                                    type='radio'
                                                    name='planDocumentsAddress'
                                                    id='serviceaddress'
                                                    onChange={handleRadioChange}
                                                    checked={selectedAddress === 'serviceaddress'}
                                                />
                                                <Label
                                                    className={`${styles.radioLabel} controls-label`}
                                                    for='serviceaddress'
                                                >
                                                    <span>
                                                        {serviceAddress.address1}, {serviceAddress.address2}{' '}
                                                        {serviceAddress.city}, {serviceAddress.state}{' '}
                                                        {serviceAddress.zip}
                                                    </span>
                                                </Label>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Col>
                        </div>
                        <Col className='p-0 mb-3 col-md-6'>
                            <div className={styles.reviewPlanBtnWrapper}>
                                <button
                                    role='button'
                                    className={classNames(btnsecondary, btn)}
                                    aria-label='Click back to open shop plans screen'
                                    onClick={handleEdit}
                                >
                                    Edit
                                </button>
                                <SpinnerButton
                                    text='Checkout'
                                    onClick={handleContinue}
                                    spinning={isLoading}
                                    disabled={isLoading}
                                    ariaLabel='Click continue to open to review the plan details screen'
                                />
                            </div>
                            <div className={`mt-4 ${styles.saveLaterBtn}`}>
                                <a
                                    onClick={(e) => handleShowActionModal()}
                                    className={classNames(btnLink, styles.saveForLater)}
                                >
                                    Save For Later
                                </a>
                            </div>
                        </Col>
                    </Col>
                    <Col
                        className='mb-3 mt-5 mt-lg-0 mt-md-0'
                        md={{ size: '5', offset: 0 }}
                        lg={{ size: '5', offset: 1 }}
                        xs={{ size: '12', order: 2 }}
                    >
                        <OrderSummary
                            updateTotal={calculateTotals}
                            clientId={clientId}
                        />
                        <CallBanner phoneNumber={phoneNumber} />
                    </Col>
                </Row>
                {showSaveModal && (
                    <SaveModal
                        isOpen={true}
                        centered={true}
                        customerData={formData}
                        planData={planData}
                        clientId={clientId}
                        toggle={() => setShowSaveModal(false)}
                        comingFrom={'ReviewPlanDetails'}
                        promoCodeData={isPromoApplied ? promocodeObj : null}
                    />
                )}
            </Form>
        </div>
    );
};

export default ReviewPlanDetails;
